import React from 'react';

const BackgroundTheme = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-100">
      {children}
    </div>
  );
};

export default BackgroundTheme;
